/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ClientActivationService } from './services/client-activation.service';
import { DocumentService } from './services/document.service';
import { AdminDocumentOverviewService } from './services/admin-document-overview.service';
import { DealStatementsService } from './services/deal-statements.service';
import { PartnerUserManagementService } from './services/partner-user-management.service';
import { PartnerOrganizationManagementService } from './services/partner-organization-management.service';
import { PartnerActivationService } from './services/partner-activation.service';
import { ClientApplicationPreloadService } from './services/client-application-preload.service';
import { ClientApplicationUnauthenticatedPreloadService } from './services/client-application-unauthenticated-preload.service';
import { AdminApplicationPreloadService } from './services/admin-application-preload.service';
import { PartnerApplicationPreloadService } from './services/partner-application-preload.service';
import { ChangePasswordService } from './services/change-password.service';
import { AdminClientManagementService } from './services/admin-client-management.service';
import { AdminClientManagementDeleteClientService } from './services/admin-client-management-delete-client.service';
import { LoginService } from './services/login.service';
import { LogoutService } from './services/logout.service';
import { RefreshSessionService } from './services/refresh-session.service';
import { ClientRegistrationService } from './services/client-registration.service';
import { ResetPasswordService } from './services/reset-password.service';
import { AdminAuditLogManagementService } from './services/admin-audit-log-management.service';
import { DeleteClientService } from './services/delete-client.service';
import { LocaleManagementService } from './services/locale-management.service';
import { ParameterManagementService } from './services/parameter-management.service';
import { NotificationHistoryService } from './services/notification-history.service';
import { DynamicDtoConfigControllerService } from './services/dynamic-dto-config-controller.service';
import { ClientDealManagementService } from './services/client-deal-management.service';
import { AdminProductGroupManagementService } from './services/admin-product-group-management.service';
import { AdminDealProductGroupStatusManagementService } from './services/admin-deal-product-group-status-management.service';
import { LoggerControllerService } from './services/logger-controller.service';
import { ClientCalculationManagementService } from './services/client-calculation-management.service';
import { AdminCalculationProductGroupManagementService } from './services/admin-calculation-product-group-management.service';
import { AdminCustomerOverviewManagementService } from './services/admin-customer-overview-management.service';
import { MessagesControllerService } from './services/messages-controller.service';
import { MessagesAdminControllerService } from './services/messages-admin-controller.service';
import { ShortTermAuthTokenControllerService } from './services/short-term-auth-token-controller.service';
import { HelloService } from './services/hello.service';
import { HelloWebService } from './services/hello-web.service';
import { AdminWebformService } from './services/admin-webform.service';
import { WebformControllerService } from './services/webform-controller.service';
import { AdminDealReviewService } from './services/admin-deal-review.service';
import { ClientDealReviewService } from './services/client-deal-review.service';
import { DealAdminAssignmentManagementService } from './services/deal-admin-assignment-management.service';
import { LeadAdminAssignmentManagementService } from './services/lead-admin-assignment-management.service';
import { LoanApplicationAdminAssignmentManagementService } from './services/loan-application-admin-assignment-management.service';
import { AdminManagementService } from './services/admin-management.service';
import { CallLogService } from './services/call-log.service';
import { AdminDocumentGenerationService } from './services/admin-document-generation.service';
import { ClientDocumentGenerationService } from './services/client-document-generation.service';
import { StatementsSigningManagementService } from './services/statements-signing-management.service';
import { ClientReactivationService } from './services/client-reactivation.service';
import { CustomerActionService } from './services/customer-action.service';
import { ExternalLoanApplicationManagementService } from './services/external-loan-application-management.service';
import { LoanApplicationManagementService } from './services/loan-application-management.service';
import { WorkerLoanApplicationManagementService } from './services/worker-loan-application-management.service';
import { CommentsService } from './services/comments.service';
import { ExternalDocumentAccessService } from './services/external-document-access.service';
import { AdminBreakGlassService } from './services/admin-break-glass.service';
import { ClientBreakGlassService } from './services/client-break-glass.service';
import { SubformsService } from './services/subforms.service';
import { CalculatorTemplateService } from './services/calculator-template.service';
import { TaskEngineService } from './services/task-engine.service';
import { OtherTasksService } from './services/other-tasks.service';
import { ClientPreVerificationService } from './services/client-pre-verification.service';
import { AdminPreVerificationService } from './services/admin-pre-verification.service';
import { SystemEventLogAdminService } from './services/system-event-log-admin.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ClientActivationService,
    DocumentService,
    AdminDocumentOverviewService,
    DealStatementsService,
    PartnerUserManagementService,
    PartnerOrganizationManagementService,
    PartnerActivationService,
    ClientApplicationPreloadService,
    ClientApplicationUnauthenticatedPreloadService,
    AdminApplicationPreloadService,
    PartnerApplicationPreloadService,
    ChangePasswordService,
    AdminClientManagementService,
    AdminClientManagementDeleteClientService,
    LoginService,
    LogoutService,
    RefreshSessionService,
    ClientRegistrationService,
    ResetPasswordService,
    AdminAuditLogManagementService,
    DeleteClientService,
    LocaleManagementService,
    ParameterManagementService,
    NotificationHistoryService,
    DynamicDtoConfigControllerService,
    ClientDealManagementService,
    AdminProductGroupManagementService,
    AdminDealProductGroupStatusManagementService,
    LoggerControllerService,
    ClientCalculationManagementService,
    AdminCalculationProductGroupManagementService,
    AdminCustomerOverviewManagementService,
    MessagesControllerService,
    MessagesAdminControllerService,
    ShortTermAuthTokenControllerService,
    HelloService,
    HelloWebService,
    AdminWebformService,
    WebformControllerService,
    AdminDealReviewService,
    ClientDealReviewService,
    DealAdminAssignmentManagementService,
    LeadAdminAssignmentManagementService,
    LoanApplicationAdminAssignmentManagementService,
    AdminManagementService,
    CallLogService,
    AdminDocumentGenerationService,
    ClientDocumentGenerationService,
    StatementsSigningManagementService,
    ClientReactivationService,
    CustomerActionService,
    ExternalLoanApplicationManagementService,
    LoanApplicationManagementService,
    WorkerLoanApplicationManagementService,
    CommentsService,
    ExternalDocumentAccessService,
    AdminBreakGlassService,
    ClientBreakGlassService,
    SubformsService,
    CalculatorTemplateService,
    TaskEngineService,
    OtherTasksService,
    ClientPreVerificationService,
    AdminPreVerificationService,
    SystemEventLogAdminService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
